import React from "react";
import { FormattedMessage } from "react-intl";
import * as S from "./styles";
import { Container } from "../Container";
/**
 * Template for empty cart page.
 */

var CartEmpty = function CartEmpty(_ref) {
  var button = _ref.button;
  return React.createElement(Container, null, React.createElement(S.Wrapper, null, React.createElement(S.TitleFirstLine, null, React.createElement(FormattedMessage, {
    id: "@next.components.templates.CartEmpty.CartEmpty.2046401791",
    defaultMessage: "Ihr Warenkorb"
  })), React.createElement(S.TitleSecondLine, null, React.createElement(FormattedMessage, {
    id: "@next.components.templates.CartEmpty.CartEmpty.1864355600",
    defaultMessage: "sieht leer aus"
  })), React.createElement(S.HR, null), React.createElement(S.Subtitle, null, React.createElement(FormattedMessage, {
    id: "@next.components.templates.CartEmpty.CartEmpty.3569309435",
    defaultMessage: "Vielleicht haben Sie Ihre Wahl noch nicht getroffen"
  })), React.createElement(S.ContinueButton, null, button)));
};

export { CartEmpty };